import { render } from "./NewExpenseTab.vue?vue&type=template&id=bfd8cc02&ts=true"
import script from "./NewExpenseTab.vue?vue&type=script&lang=ts"
export * from "./NewExpenseTab.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\EugenePrice\\repos\\thinkspatial\\expenses-ionic-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__